// Generated by Melange

import NowPlayingModuleCss from "./nowPlaying.module.css";
import * as ReactRouter from "@tanstack/react-router";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as LucideReact from "../lucideReact/lucideReact.jsx";
import * as Router__Link from "../router/link.jsx";
import * as Shared__Album from "./album.jsx";
import * as Shared__Button from "./button.jsx";
import * as Shared__Container from "./container.jsx";
import * as Shared__CoverArt from "./coverArt.jsx";
import * as Shared__DropdownMenu from "./dropdownMenu.jsx";
import * as Shared__Skeleton from "./skeleton.jsx";
import * as Shared__StarButton from "./starButton.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Context from "../store/context.jsx";
import * as LucideReact$1 from "lucide-react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = NowPlayingModuleCss;

function NowPlaying(Props) {
  const navigate = ReactRouter.useNavigate();
  const clearSubsonicCredentials = Store__Context.useAppStore(function (state) {
    return state.auth.clearSubsonicCredentials;
  });
  const currentSongId = Store__Context.useAppStore(function (state) {
    return state.player.currentSongId;
  });
  const song = Store__Context.useAppStore(function (state) {
    return Stdlib__Option.bind(currentSongId, (function (currentSongId) {
      return Caml_option.undefined_to_opt(state.songs.byId.get(currentSongId));
    }));
  });
  let tmp = {
    className: css.coverArt,
    lazy: true,
    sizes: "3em"
  };
  const tmp$1 = Stdlib__Option.map((function (song) {
    return song.coverArt;
  }), song);
  if (tmp$1 !== undefined) {
    tmp.coverArt = Caml_option.valFromOption(tmp$1);
  }
  let tmp$2;
  if (song !== undefined) {
    const artistId = song.artistId;
    tmp$2 = JsxRuntime.jsxs("span", {
      children: [
        React.cloneElement(artistId !== undefined ? JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, undefined, undefined, undefined, undefined, {
            artistId: artistId
          }, undefined, "/artist/$artistId", undefined)) : JsxRuntime.jsx("span", {}), {
          "aria-label": "Artist",
          children: [
            song.artist,
            " ",
            JsxRuntime.jsx("span", {
              children: " – ",
              "aria-hidden": true
            }, "span")
          ]
        }),
        " ",
        JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps("Album", Caml_option.some(song.album), undefined, undefined, undefined, {
          albumId: song.albumId
        }, undefined, "/album/$albumId", undefined))
      ],
      className: css.artistAndAlbum
    });
  } else {
    tmp$2 = currentSongId !== undefined ? JsxRuntime.jsx(Shared__Skeleton.make, {
        className: css.skeletonLine2
      }) : null;
  }
  let tmp$3 = {
    className: css.starButton,
    disabled: Stdlib__Option.is_none(song)
  };
  const tmp$4 = Stdlib__Option.map((function (song) {
    return song.id;
  }), song);
  if (tmp$4 !== undefined) {
    tmp$3.id = Caml_option.valFromOption(tmp$4);
  }
  const tmp$5 = Stdlib__Option.bind(song, (function (song) {
    return song.starred;
  }));
  if (tmp$5 !== undefined) {
    tmp$3.starred = Caml_option.valFromOption(tmp$5);
  }
  return JsxRuntime.jsxs(Shared__Container.make, {
    children: [
      JsxRuntime.jsx(Shared__CoverArt.make, tmp),
      JsxRuntime.jsxs("div", {
        children: [
          song !== undefined ? JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps("Song", Caml_option.some(song.title), undefined, Shared__Album.getSongElementId(song.id), {
                behavior: "instant",
                block: "nearest"
              }, {
                albumId: song.albumId
              }, undefined, "/album/$albumId", undefined)),
              className: css.name
            }) : (
              currentSongId !== undefined ? JsxRuntime.jsx(Shared__Skeleton.make, {
                  className: css.skeletonLine1
                }) : null
            ),
          tmp$2
        ],
        className: css.info
      }),
      JsxRuntime.jsx(Shared__StarButton.make, tmp$3),
      JsxRuntime.jsxs(Shared__DropdownMenu.Root.make, {
        children: [
          JsxRuntime.jsx(Shared__DropdownMenu.Trigger.make, {
            children: JsxRuntime.jsx(Shared__Button.make, {
              ariaLabel: "Menu",
              children: JsxRuntime.jsx(LucideReact$1.Menu, Curry._4(LucideReact.Menu.makeProps, undefined, undefined, undefined, undefined)),
              className: css.dropdownMenuButton,
              variant: "icon"
            })
          }),
          JsxRuntime.jsxs(Shared__DropdownMenu.Content.make, {
            children: [
              JsxRuntime.jsxs(Shared__DropdownMenu.Item.make, {
                children: [
                  JsxRuntime.jsx(LucideReact$1.Home, Curry._4(LucideReact.Home.makeProps, undefined, undefined, "none", undefined)),
                  "Home"
                ],
                onClick: (function (param) {
                  Curry._1(navigate, {
                    to: "/"
                  });
                })
              }),
              JsxRuntime.jsx("form", {
                children: JsxRuntime.jsxs(Shared__DropdownMenu.Item.make, {
                  children: [
                    JsxRuntime.jsx(LucideReact$1.LogOut, Curry._4(LucideReact.LogOut.makeProps, undefined, undefined, "none", undefined)),
                    "Logout"
                  ],
                  type_: "submit"
                }),
                onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(clearSubsonicCredentials, undefined);
                })
              })
            ],
            placement: "bottomEnd",
            strategy: "fixed"
          })
        ]
      })
    ],
    className: css.root
  });
}

const make = NowPlaying;

export {
  make,
}
/* css Not a pure module */
